module.exports = __webpack_public_path__ + "static/media/Keats_and_Beats.848093b1.md";